import { fetchWithAuth } from "digimaker-ui/util";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import { AutoSearch, convertHighlighted, getLink } from "./AutoSearch";
import moment from "moment";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router";
import i18n from "eth-common/i18n/i18n";
import { EthContext } from "eth-common/EthContext";
import Select from "react-select";

export const Resource2 = (props: { content: any }) => {
  const [tags, setTags] = useState<
    { value: number; label: string; display_order: number }[]
  >([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [keyword, setKeyword] = useState<string>("");
  const [total, setTotal] = useState<number>(-1);
  const pageSize = 15;
  const [page, setPage] = useState<number>(1);
  const [searched, setSearched] = useState<boolean>(false);
  const [fieldDefinition, setFieldDefinition] = useState<any[]>([]);
  const location = useLocation();

  const [selectedFilters, setSelectedFilters] = useState<
    Record<string, string[] | undefined>
  >({});

  const [facets, setFacets] = useState<Record<string, Record<string, number>>>(
    {},
  );
  const [list, setList] = useState<any[]>([]);

  const fetchTags = async () => {
    const result = await fetchWithAuth(
      "/api/content/list/resource_tag?limit=1000&sortby=c.display_order desc",
    );
    if (result.error === false) {
      setTags(
        result.data.list.map((item: any) => ({
          value: item.id,
          label: language === "eng-GB" ? item.english : item.title,
          display_order: item.display_order || 0,
        })),
      );
    }
  };

  useEffect(() => {
    fetchTags();
    fetchDefinition();
  }, []);

  useEffect(() => {
    if (location.search) {
      const params = new URLSearchParams(location.search);
      const tags = params.get("tags");
      const q = params.get("q");
      const currentTags = tags ? tags.split(",") : [];
      setSelectedTags(currentTags);
      setSelectedFilters({});
      if (q) {
        setKeyword(q);
      }
      search({ currentKeyword: q || "", currentTags: currentTags });
    }
  }, [location.search]);

  const language = (useContext(EthContext) as any).language;

  const fetchDefinition = async () => {
    const result = await fetchWithAuth(
      "/api/contenttype/get/resource2?language=" + language,
    );
    if (result.error === false) {
      setFieldDefinition(result.data.fields);
    }
  };

  const search = async (params?: {
    currentKeyword?: string;
    currentTags?: any;
    currentSelectedFilters?: any;
  }) => {
    const currentKeyword =
      params && params.currentKeyword ? params.currentKeyword : keyword;
    const currentTags =
      params && params.currentTags ? params.currentTags : selectedTags;
    const currentSelectedFilters =
      params && params.currentSelectedFilters
        ? params.currentSelectedFilters
        : selectedFilters;

    const result = await fetchWithAuth(
      "/api/eth/search?type=resource2&q=" +
        currentKeyword +
        "&content=true&offset=" +
        (page - 1) * pageSize +
        "&limit=" +
        pageSize,
      {
        method: "POST",
        body: JSON.stringify({
          filters: currentSelectedFilters,
          pre_filters:
            currentTags.length > 0
              ? {
                  tags_ids: currentTags,
                }
              : undefined,
        }),
      },
    );
    setSearched(true);
    if (result.error === false) {
      setList(result.data.list);
      setFacets(result.data.facets);
      setTotal(result.data.total);
    }
  };

  useEffect(() => {
    if (searched) {
      setPage(1);
      search();
    }
  }, [selectedFilters]);

  useEffect(() => {
    if (searched) {
      search();
    }
  }, [page]);

  const getTagId = (value: string, name: string) => {
    return value + "__" + name;
  };

  const getLabels = (attribute: string, keys: string[]) => {
    const labels: Record<string, string> = {};
    const field = fieldDefinition.find(
      (field) => field.identifier === attribute,
    );

    const options = field.parameters.list;
    keys.map((key) => {
      labels[key] = options.find((option) => option.value === key).text || key;
    });
    return labels;
  };

  const getFieldName = (attribute: string) => {
    const field = fieldDefinition.find(
      (field) => field.identifier === attribute,
    );
    return field.name || attribute;
  };

  return (
    <div>
      <h2>{i18n.t("Search on resources")}</h2>
      <div
        style={{
          marginTop: "40px",
        }}
      >
        <div style={{ justifyContent: "center", display: "flex", gap: "10px" }}>
          <div style={{ width: 500 }}>
            <AutoSearch
              mode="full"
              currentKeyword={keyword}
              onChange={(value) => setKeyword(value)}
              onSubmit={() => {
                setSelectedFilters({});
                search();
              }}
            />
          </div>
          <button className="btn btn-primary" onClick={() => search()}>
            <i className="fa fa-search" /> &nbsp; {i18n.t("Search")}
          </button>
          <button
            className="btn btn-link"
            style={{ color: "#333" }}
            onClick={() => {
              setKeyword("");
              setSelectedTags([]);
              setSelectedFilters({});
              setPage(1);
              search();
            }}
          >
            {i18n.t("Show all")}
          </button>
        </div>
        <div className="mt-4">
          <div
            className="d-flex justify-content-center flex-wrap"
            style={{ gap: 5 }}
          >
            {tags
              .filter(
                (tag) =>
                  tag.display_order > 0 ||
                  selectedTags.includes(getTagId(tag.value + "", tag.label)),
              )
              .map((tag) => {
                const idString = getTagId(tag.value + "", tag.label);

                const selected = selectedTags.includes(idString);

                return (
                  <div
                    key={tag.value}
                    className="d-inline mr-2 position-relative"
                  >
                    {tag.value && selected && (
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTags(
                            selectedTags.filter((item) => item !== idString),
                          );
                        }}
                        aria-label={i18n.t("Remove tag") + " " + tag.label}
                        style={{
                          fontSize: 12,
                          height: 18,
                          width: 18,
                          lineHeight: "18px",
                          textAlign: "center",
                          position: "absolute",
                          right: -5,
                          borderRadius: 10,
                          top: -5,
                          color: "white",
                          background: "#333",
                        }}
                      >
                        <i className="fa fa-times"></i>
                      </a>
                    )}
                    <div
                      className={
                        "search-select" + (selected ? " selected" : "")
                      }
                      key={tag.value}
                      onClick={() =>
                        setSelectedTags([...selectedTags, idString])
                      }
                    >
                      {tag.label}
                    </div>
                  </div>
                );
              })}

            <div>
              <div style={{ width: 130 }}>
                <Select
                  value={null}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral20: "#eee",
                    },
                    spacing: {
                      ...theme.spacing,
                      controlHeight: 40,
                    },
                  })}
                  placeholder={i18n.t("More")}
                  onChange={(item: any) => {
                    if (item) {
                      setSelectedTags([
                        ...selectedTags,
                        getTagId(item.value + "", item.label),
                      ]);
                    }
                  }}
                  options={tags
                    .filter(
                      (tag) =>
                        tag.display_order <= 0 &&
                        !selectedTags.includes(
                          getTagId(tag.value + "", tag.label),
                        ),
                    )
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .map((tag) => ({ value: tag.value, label: tag.label }))}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {searched && (
        <div className="mt-4">
          <div className="mt-4 p-4">
            {list.length === 0 && (
              <div className="mt-4 alert alert-info">
                <p>{i18n.t("No result found")}</p>
              </div>
            )}
            {list.map((item) => {
              const content = item.content;
              const link = getLink(content);
              return (
                <div key={item.id} className="mb-4 border-bottom pb-2">
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <div className="d-flex justify-content-between align-items-center">
                      <h4>{content.metadata.name}</h4>
                      <span style={{ fontSize: 16 }}>
                        {content.file ? (
                          <i className="fa fa-download" aria-hidden="true"></i>
                        ) : null}
                        {content.link ? (
                          <i
                            className="fas fa-external-link-alt"
                            aria-hidden="true"
                          ></i>
                        ) : null}
                      </span>
                    </div>
                  </a>
                  <div
                    dangerouslySetInnerHTML={{ __html: content.description }}
                  />
                  <div>
                    <p>{convertHighlighted(item._highlighted.value)}</p>
                    <div className="d-flex justify-content-between align-items-center gap-3">
                      <div>
                        {item.tags.map((tag) => (
                          <span
                            key={tag.id}
                            className="d-inline-block mt-2 mr-2 border bg-light rounded"
                            style={{ padding: "2px 5px" }}
                          >
                            {tag.name}
                          </span>
                        ))}
                      </div>
                      <div>
                        {moment(content.metadata.modified).format(
                          "DD.MM.YYYY HH:mm",
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            {total > 0 && (
              <div
                className="d-flex justify-content-between"
                style={{ marginTop: 50 }}
              >
                <div className=" align-items-center gap-3">
                  {i18n.t("Total")}: {total}
                </div>
                <div className="d-flex  align-items-center" style={{ gap: 5 }}>
                  <span>
                    {page}/{Math.ceil(total / pageSize)}
                  </span>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                    aria-label={i18n.t("Previous page")}
                  >
                    <i className="fa fa-chevron-left" />
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    disabled={page === Math.ceil(total / pageSize)}
                    onClick={() => setPage(page + 1)}
                    aria-label={i18n.t("Next page")}
                  >
                    <i className="fa fa-chevron-right" />
                  </button>
                </div>
              </div>
            )}
          </div>

          {list.length > 0 && Object.keys(facets).length > 0 && (
            <div
              className="mt-4 p-2"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: 10,
                border: "1px solid #f0f0f0",
                backgroundColor: "#f9f9f9",
              }}
            >
              <FilterItem
                name={getFieldName("tags")}
                selected={selectedFilters["tags_ids"]}
                labels={Object.fromEntries(
                  Object.keys(facets["tags_ids"]).map((key) => [
                    key,
                    key.split("__")[1],
                  ]),
                )}
                counts={facets["tags_ids"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    tags_ids: key ? [key] : undefined,
                  })
                }
              />
              <FilterItem
                name={getFieldName("year")}
                selected={selectedFilters["year.value"]}
                labels={getLabels("year", Object.keys(facets["year.value"]))}
                counts={facets["year.value"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    "year.value": key ? [key] : undefined,
                  })
                }
              />
              <FilterItem
                name={getFieldName("country")}
                selected={selectedFilters["country.value"]}
                labels={getLabels(
                  "country",
                  Object.keys(facets["country.value"]),
                )}
                counts={facets["country.value"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    "country.value": key ? [key] : undefined,
                  })
                }
              />
              <FilterItem
                name={getFieldName("industry")}
                selected={selectedFilters["industry.value"]}
                labels={getLabels(
                  "industry",
                  Object.keys(facets["industry.value"]),
                )}
                counts={facets["industry.value"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    "industry.value": key ? [key] : undefined,
                  })
                }
              />
              <FilterItem
                name={getFieldName("type")}
                selected={selectedFilters["type.value"]}
                labels={getLabels("type", Object.keys(facets["type.value"]))}
                counts={facets["type.value"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    "type.value": key ? [key] : undefined,
                  })
                }
              />
              <FilterItem
                name={getFieldName("language")}
                selected={selectedFilters["language.value"]}
                labels={getLabels(
                  "language",
                  Object.keys(facets["language.value"]),
                )}
                counts={facets["language.value"]}
                onSelect={(key) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    "language.value": key ? [key] : undefined,
                  })
                }
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const FilterItem = (props: {
  name: string;
  selected?: string[];
  labels: Record<string, string>;
  counts: Record<string, number>;
  onSelect?: (key: string | undefined) => void;
}) => {
  const { name, labels, counts, selected, onSelect } = props;

  const select = (key) => {
    if (onSelect) {
      if (key) {
        onSelect(key);
      } else {
        onSelect(undefined);
      }
    }
  };

  return (
    <div>
      <div>
        <div className="font-weight-bold border-bottom pb-2">{name}:</div>
        <div className="p-2 d-flex flex-wrap" style={{ gap: 5 }}>
          {Object.keys(counts)
            .filter(
              (key: string) =>
                !selected || (selected && selected.includes(key)),
            )
            .map((key: string) => {
              return (
                <div
                  key={key}
                  onClick={() => select(key)}
                  className={
                    selected && selected.includes(key)
                      ? "cursor-pointer border bg-white border-radius-5 p-1"
                      : "search-select-attribute p-1"
                  }
                  style={{ cursor: "pointer", color: "#666" }}
                >
                  <span>{labels[key]}</span>
                  <span className="ml-1">({counts[key]})</span>
                </div>
              );
            })}
          {selected && (
            <Button
              size="sm"
              variant="light"
              onClick={() => select(undefined)}
              aria-label={i18n.t("Clear filter")}
            >
              <i className="fa fa-times" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
